// extracted by mini-css-extract-plugin
export default {"flowsheetWarningPopupFooter":"FlowsheetWarningPopup_flowsheetWarningPopupFooter__oRXFM","flowsheetWarningPopupMessage":"FlowsheetWarningPopup_flowsheetWarningPopupMessage__2fXKu"};